
(function () {
  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function initRechargeUnitPrice() {
   
    if (!window.ALL_PRODUCTS || !window.ALL_PRODUCTS.length) return;
    
    var variantToMainId = (function buildVariantMap() {
      var map = {};
      var all = Array.isArray(window.ALL_PRODUCTS) ? window.ALL_PRODUCTS : [];

      all.forEach(function (p) {
        if (!p || p.id == null) return;
        var mainId = p.id;
        var vars = Array.isArray(p.variants) ? p.variants : [];

        vars.forEach(function (v) {
          if (!v || v.id == null) return;
          map[String(v.id)] = mainId;
        });
      });

      return map;
    })();
 
    $('.rb-addon-item').each(function () {
      var $item = $(this);
 
      $item.find('p').addClass('rb-price');
      $item.find('.rb-title').removeClass('rb-price');
 
      var $select = $item.find('select.rb-select.rb-variant-selector').first();
      if (!$select.length) return;

      var selectedVariantId = String($select.val() || '');
      var mainId = variantToMainId[selectedVariantId];
 
      var $tflex = $item.closest('.tflex');
 
      if (!$tflex.length) $tflex = $item.find('.tflex').first();

      if (!$tflex.length) return;

      if (mainId) {
        $tflex.attr('data-rb-item-id', String(mainId));
      } else { 
        $tflex.removeAttr('data-rb-item-id');   
      }
    
    });      

    $(document).on('change', 'select.rb-select.rb-variant-selector', function () {
      var $select = $(this);
      var selectedVariantId = String($select.val() || '');
      var mainId = variantToMainId[selectedVariantId];

      var $item = $select.closest('.rb-addon-item');
      var $tflex = $item.closest('.tflex');
      if (!$tflex.length) $tflex = $item.find('.tflex').first();
      if (!$tflex.length) $tflex = $select.closest('.tflex');

      if (!$tflex.length) return;

      if (mainId) {
        $tflex.attr('data-rb-item-id', String(mainId));
      } else {
        $tflex.removeAttr('data-rb-item-id');   
      }
    });       
    
    function normalizeTitle(str) {
      return (str || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }

    // Map products by normalized title
    const productByTitle = new Map(
      (window.ALL_PRODUCTS || []).map(p => [normalizeTitle(p.title), p])
    );
   
    document.querySelectorAll('#recharge-bundles .rb-items-wrapper .tflex').forEach(rbItem => {
      
      const titleEl = rbItem.querySelector('.rb-title');
      if (!titleEl) return;
       
      const domTitle = normalizeTitle(titleEl.textContent);
      const product = productByTitle.get(domTitle);
      if (!product) return;
      console.log(domTitle)
      const variant = (product.variants || [])[0];
      if (!variant) return;

      const priceEl = rbItem.querySelector('.rb-price');
      if (!priceEl) return;
      console.log(variant)
      // Prevent double-binding  
      if (rbItem.dataset.unitPriceBound === 'true') return;
      rbItem.dataset.unitPriceBound = 'true';

      if (!rbItem.querySelector('.recharge-unit-price')) {
        // Insert UI once
        priceEl.insertAdjacentHTML(
          'afterend',
          `<div class="recharge-unit-price product-item__price text-size--large" style="font-size:18px; color:#000000;margin-bottom:14px;">
            <div class="unit-price product-price--original"></div>
            <div class="package-price product-price--unit text-size--regular" style="display:block;padding-inline-start:0 !important;opacity:.62;font-size:80%;margin-top:-.125rem;margin-bottom:.125rem;"></div>
          </div>`
        ); 
      }

      // Hide original price block
      priceEl.style.display = 'none';

      const unitPriceEl = rbItem.querySelector('.unit-price');
      const packagePriceEl = rbItem.querySelector('.package-price');

      // Unit price
      if (variant.price_per_unit && variant.price_per_unit !== "null") {
        unitPriceEl.textContent = `$${Number(variant.price_per_unit).toFixed(2)} / lb`;
      } else {
        unitPriceEl.textContent = '';
      }

      // Package price
      packagePriceEl.textContent = `~ ${formatMoney(variant.price)} / package`;
    });

  }

  document.addEventListener('DOMContentLoaded', () => {
    initRechargeUnitPrice();

    const observer = new MutationObserver(initRechargeUnitPrice);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();

 (function () {
  const moveCredits = () => {
    const creditWrapper = document.querySelector('.recharge-component-credit-balance')?.parentElement;
    if (!creditWrapper) return;

    creditWrapper.style.order = '-10';
  };

  const observer = new MutationObserver(() => {
    moveCredits();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  moveCredits();
})();
 



// (function () {
//   const isSubscriptionsPage = () =>
//     window.location.pathname.includes('/tools/recurring/portal') &&
//     window.location.pathname.includes('/overview');

//   if (!isSubscriptionsPage()) return;

//   const interval = setInterval(() => {
//     const rechargeHeader = document.querySelector('.main-header');
//     const pageContainer =
//       document.querySelector('[data-testid="page-container"]') ||
//       document.querySelector('#root');

//     if (!rechargeHeader || !pageContainer) return;

//     clearInterval(interval);

//     if (document.querySelector('.cloned-orders-header')) return;

//     const clonedHeader = rechargeHeader.cloneNode(true);
//     clonedHeader.classList.add('cloned-orders-header');

//     pageContainer.insertBefore(clonedHeader, pageContainer.firstChild);

//     rechargeHeader.remove();
//   }, 300);
// })(); 


(function () {
  function formatMoney(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function normalizeTitle(str) {
    return (str || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function moneyTextToCents(str) {
    if (!str) return null;
    var cleaned = String(str).replace(/\s+/g, ' ').trim().replace(/[^0-9.,]/g, '');
    if (!cleaned) return null;

    var lastDot = cleaned.lastIndexOf('.');
    var lastComma = cleaned.lastIndexOf(',');

    if (lastComma > lastDot) cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    else cleaned = cleaned.replace(/,/g, '');

    var num = Number(cleaned);
    if (!isFinite(num)) return null;
    return Math.round(num * 100);
  }

  function extractPrices(priceEl) {
    var compareEl = priceEl.querySelector('s');
    var compareCents = compareEl ? moneyTextToCents(compareEl.textContent) : null;

    var txt = (priceEl.textContent || '').trim();
    var matches = txt.match(/\$?\s?\d[\d,]*(?:\.\d{1,2})?/g);
    var currentCents = matches && matches.length ? moneyTextToCents(matches[matches.length - 1]) : null;

    return { compareCents: compareCents, currentCents: currentCents };
  }

  function closestItemContainer(priceEl) {
    // Works for both grid items and carousel items
    return (
      priceEl.closest('.recharge-component-product-item') ||
      priceEl.closest('.recharge-component-carousel-item') ||
      priceEl.closest('[data-carousel-item="true"]') ||
      priceEl.closest('[role="dialog"]') ||
      priceEl.closest('div')
    );
  }

  function isLikelyTitle(text) {
    if (!text) return false;
    var t = text.trim();
    if (t.length < 4) return false;
    if (t.toLowerCase() === 'swap') return false;
    if (/\$?\s?\d[\d,]*(?:\.\d{1,2})?/.test(t) && t.length < 20) return false; // money-like
    return true;
  }

  function findTitleNearPrice(priceEl) {
    var card = closestItemContainer(priceEl);
    if (!card) return '';

    // Try obvious hooks first (if they exist)
    var t =
      card.querySelector('[data-testid="product-title"]') ||
      card.querySelector('[data-testid="product-name"]') ||
      card.querySelector('.rb-title') ||
      card.querySelector('h1,h2,h3,h4');

    if (t && isLikelyTitle(t.textContent)) return t.textContent.trim();

    // Fallback: find the nearest previous text node above price inside the card
    // We'll scan elements in DOM order and pick the last "title-like" before priceEl.
    var all = Array.prototype.slice.call(card.querySelectorAll('p,span,div,h1,h2,h3,h4'));
    var lastTitle = '';
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (!el || el === priceEl) continue;
      if (el.contains(priceEl)) continue;

      // stop once we pass the priceEl in DOM order
      // (cheap check: if priceEl comes after el, keep updating)
      // If DOM order check isn't perfect, this still usually works.
      var txt = (el.textContent || '').trim();
      if (isLikelyTitle(txt)) lastTitle = txt;
    }

    return lastTitle || '';
  }

  function buildUnitLineFromVariant(variant) {
    // Liquid equivalent: unit_price + measurement
    if (variant && variant.unit_price != null && variant.unit_price_measurement) {
      var m = variant.unit_price_measurement || {};
      var refVal = Number(m.reference_value || 1);
      var refUnit = String(m.reference_unit || '').trim();

      if (refUnit) {
        var out = formatMoney(variant.unit_price) + ' / ';
        if (refVal !== 1) out += refVal;
        out += refUnit;
        return out;
      }
    }

    // Fallback: custom field you used earlier
    if (variant && variant.price_per_unit && variant.price_per_unit !== "null") {
      return '$' + Number(variant.price_per_unit).toFixed(2) + ' / lb';
    }

    return '';
  }

  function initRechargePortalPricesAll() {
    if (!window.ALL_PRODUCTS || !window.ALL_PRODUCTS.length) return;

    var productByTitle = new Map(
      (window.ALL_PRODUCTS || []).map(function (p) {
        return [normalizeTitle(p && p.title), p];
      })
    );

    document.querySelectorAll('div[data-testid="product-price"]').forEach(function (priceEl) {
      if (!priceEl) return;

      // If already replaced, skip
      if (priceEl.querySelector('.rb-price-ui')) return;

      var title = findTitleNearPrice(priceEl);
      if (!title) return;

      var product = productByTitle.get(normalizeTitle(title));

      // Soft match fallback
      if (!product) {
        var nt = normalizeTitle(title);
        for (var i = 0; i < window.ALL_PRODUCTS.length; i++) {
          var p = window.ALL_PRODUCTS[i];
          var pt = normalizeTitle(p && p.title);
          if (!pt) continue;
          if (nt === pt || nt.indexOf(pt) > -1 || pt.indexOf(nt) > -1) {
            product = p;
            break;
          }
        }
      }
      if (!product) return;

      var prices = extractPrices(priceEl);

      // Match variant using strike/compare if present (Shopify price)
      var matchCents = (prices.compareCents != null) ? prices.compareCents : prices.currentCents;
      if (matchCents == null) return;

      var variant = null;
      var vars = Array.isArray(product.variants) ? product.variants : [];

      for (var v = 0; v < vars.length; v++) {
        if (Number(vars[v].price) === Number(matchCents)) {
          variant = vars[v];
          break;
        }
      }
      if (!variant) variant = vars[0];
      if (!variant) return;

      var unitLine = buildUnitLineFromVariant(variant);

      // Package price should be Shopify price (variant.price)
      var packageLine = '~ ' + formatMoney(variant.price) + ' / package';

      priceEl.innerHTML =
        '<div class="rb-price-ui" style="text-align:center;">' +
          (unitLine
            ? '<div class="rb-unit" style="font-size:18px;color:#0c1812;margin-top:10px;">' + unitLine + '</div>'
            : ''
          ) +
          '<div class="rb-package" style="opacity:.62;font-size:85%;margin-top:6px;margin-bottom:10px;color:#0c1812;">' + packageLine + '</div>' +
        '</div>';
    });
  }

  function boot() {
    initRechargePortalPricesAll();
    var obs = new MutationObserver(function () {
      initRechargePortalPricesAll();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
